import { globalVarVue3 } from '@tencent/pmd-vue/lib/global-var-vue3';
import { startApp } from '@tencent/pmd-vue/lib/vue3-cross/start-app';
import { createSSRApp } from 'vue';

import { initNetworkManagerSmoba as initNetworkManager } from '@tencent/pmd-vue/lib/network';
import { initConfig } from '@tencent/pmd-config';

import store from './store/index';
import { lifecycleMixins } from '@tencent/pmd-vue/lib/uniapp-mixin/lifecycleMixins';
import { projectMixins } from './mixins/projectMixins.js';
import { initEnv } from '@tencent/pmd-tools/lib/env';
import vClickOutside from 'click-outside-vue3';

import App from './App.vue';
import config from './config';
import { createStore } from 'vuex';
import router from './router/vue3';
// #ifdef H5
import GlobalComponentWeb from 'src/local-component/module/tip-match/global-component/index-web.vue';
// #endif
// #ifdef MP-WEIXIN || MP-QQ
import MatchCommDialog from '@tencent/press-ui/press-dialog/press-dialog.vue';
import GlobalComponentMp from 'src/local-component/module/tip-match/global-component/index-mp.vue';
import PressQRCode from '@tencent/press-ui/press-q-r-code/press-q-r-code.vue';
import PressDialogPlus from '@tencent/press-ui/press-dialog-plus/press-dialog-plus.vue';
import PressDialog from '@tencent/press-ui/press-dialog/index';
// #endif
import { reportClick, reportPageExposure } from 'src/local-logic/tip-match/report/report';
import { initCommercialManager } from 'src/local-logic/commercial/sample/smoba';
import { DEBUG_CGI_ENV } from '@tencent/pmd-vue/lib/debug/config';


// 防止下面这些方法被 tree-shaking 掉
const originNavigateTo = uni.navigateTo;
const originNavigateBack = uni.navigateBack;
const originReplaceTo = uni.redirectTo;

uni.navigateTo = originNavigateTo;
uni.navigateBack = originNavigateBack;
uni.redirectTo = originReplaceTo;


// #ifdef H5
// 支持预发布
function initProd() {
  if (window.location.href.indexOf(`${DEBUG_CGI_ENV.KEY}=${DEBUG_CGI_ENV.PROD}`) > -1) {
    window.sessionStorage.setItem(DEBUG_CGI_ENV.KEY, DEBUG_CGI_ENV.PROD);
  }
}
initProd();

// hookRouterInPageAnimation();
// #endif


initConfig(config);
globalVarVue3({
  isSessionStoragePersist: true,
  webviewUrl: '/views/webview/webview',
});
initNetworkManager();
initCommercialManager();
// 点击态延迟相应点击事件时间
// @ts-ignore
window.DELAY_MILLISECOND = 50;

// #ifdef MP
// @ts-ignore
PressDialog.setDefaultOptions({
  selector: (context) => {
    if (!context) return;

    const globalComponent = context.selectComponent('#global-component');
    const dialog = globalComponent?.$vm?.$refs?.pressDialog;
    if (dialog) return dialog;

    const instance = globalComponent?.selectComponent('#press-dialog');
    return instance;
  },
});
// #endif

console.log('router', router);
export function createApp() {
  const app = createSSRApp(App as unknown as Element);

  // app.use(router);

  // #ifndef H5
  app.config.globalProperties.$router = router;
  app.config.globalProperties.$route = router.route;
  // #endif
  (app as any).$router = router;
  router.install(app);
  (app as any).env = initEnv();
  (app as any).reportClick = (
    secondChannel, eventId, childId = 'all',
    { teamId, scheId, battleId, elementId }: Record<string, any> = {},
  ) => {
    reportClick(secondChannel, eventId, childId, teamId, scheId, battleId, elementId);
  };

  (app as any).reportPageExposure = (
    secondChannel, childId = 'all',
    { teamId, scheId, battleId, elementId, eventId }: Record<string, string | number> = {},
  ) => {
    reportPageExposure(secondChannel, childId, teamId, scheId, battleId, elementId, eventId);
  };

  app.provide('globalUseVueQrcodeInVue3', true);


  startApp({
    config,
    app,
  });
  const tStore = createStore({ modules: store });

  app.mixin(lifecycleMixins);
  app.mixin(projectMixins);
  app.use(tStore);
  (app as any).$store = tStore;
  app.use(vClickOutside);
  // #ifdef MP
  app.component('GlobalComponent', GlobalComponentMp);
  app.component('MatchCommDialog', MatchCommDialog);
  app.component('PressQRCode', PressQRCode);
  app.component('PressDialogPlus', PressDialogPlus);
  // #endif
  // #ifdef H5
  app.component('GlobalComponent', GlobalComponentWeb);
  // #endif

  return {
    app,
  };
}

